import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFetch, { CachePolicies } from "use-http";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import style from "./inviteChat.module.css";
import searchIcon from "src/assets/png/searchIcon.png";
import close from "src/assets/png/close.png";
import { Spin, Tooltip } from "antd";
import { CloseCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { getUrlHttp } from "src/service/util.service";
import CenterButton from "src/components/shared/button/CenterButton";
import selectedItemShare from "src/assets/png/selectedItemShare.png";

const InviteChat = (props: any) => {
  const { onClose } = props;
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const getGroupID = () => {
    const search = location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);
    const groupID = params.get("id");
    if (!groupID) {
      return id
    }
    return groupID;
  };

  const outsideGroup = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
    `/api/v2/groups/outside-group/${getGroupID()}`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const invitGroup = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
    `/api/v2/groups/pending-invite/${getGroupID()}`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );


  // const testTopic = useFetch(
  //   window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
  //     `/api/v2/groups/2b554d69-b4a7-477d-a2ae-ca72af836671/members`,
  //   {
  //     cachePolicy: CachePolicies.NO_CACHE,
  //   }
  // );

  const invite = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v2/groups/invite",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [friendsOutside, setFriendsOutside] = useState([]);
  const [friendsInvite, setFriendsInvite]: any = useState([]);
  const [membersID, setMembersID]: any = useState([]);
  const [membersName, setMembersName]: any = useState([]);
  const [timer, setTimer]: any = useState(null);

  const getFriendOutside = async (search: string) => {
    const res = await outsideGroup.get(`?key=${search}`);
    if (outsideGroup.response.ok) {
      setFriendsOutside(res);
    }
    console.log("invite Outside:: ", res);
  };

  const getFriendInvite = async (search: string) => {
    const res = await invitGroup.get(`?key=${search}`);
    if (invitGroup.response.ok) {
      setFriendsInvite(res);
    }
    console.log("invite res:: ", res);
  };

  const handleSearch = (event: any) => {
    const value = event.target.value;
    setSearch(value);
    clearTimeout(timer);
    setTimer(
      setTimeout(() => {
        setFriendsOutside([]);
        setFriendsInvite([]);
        getFriendOutside(value);
        getFriendInvite(value);
      }, 300)
    );
  };

  const handleClearSeaech = () => {
    setSearch("");
    clearTimeout(timer);
    getFriendOutside("");
    getFriendInvite("");
  };

  const handleClickSelect = (member: any) => {
    let userList = Object.assign([], membersName);
    let index: any;
    const isSelected = userList.some((item: any, idx: number) => {
      let result = false;
      if (item.id === member.id) {
        index = idx;
        result = item.id === member.id;
      }
      return result;
    });

    if (isSelected) {
      userList.splice(index, 1);
    } else {
      userList.push(member);
    }
    setMembersName(userList);

    ////////////////////////////

    let userLists = Object.assign([], membersID);
    let indexID = membersID.indexOf(member.id);

    if (indexID === -1) {
      userLists.push(member.id);
    } else {
      userLists.splice(indexID, 1);
    }
    setMembersID(userLists);
  };

  const handleCancel = () => {
    if (membersID.length !== 0 || membersName.length !== 0) {
      setMembersID([]);
      setMembersName([]);
    } else {
      navigate(-1)
    }
  };

  const showMember = () => {
    console.log("membersName", membersName);
  };

  const addMember = async () => {
    const membersData = membersID.map((member: any) => {
      return { userID: member };
    });
    const data = { id: getGroupID(), members: membersData };
    await invite.post(data);
    setSearch("");
    getFriendOutside("");
    setMembersID([]);
    setMembersName([]);
    onClose?.();
  };

  // const test = async () => {
  //   const res = await testTopic.get();
  //   console.log(res);
  // };

  useEffect(() => {
    getFriendOutside(search);
    getFriendInvite(search);
    // test();

    return () => {
      outsideGroup.abort();
      invitGroup.abort();
    };
  }, []);

  const getFullName = (data: any) => {
    let name = ""
    if (data?.firstname) {
      name += data?.firstname;
    }
    if (data?.lastname) {
      name += " " + data?.lastname
    }
    return name;
  }

  useEffect(() => {
    showMember();
  }, [membersName]);
  return (
    <div className={style.inviteChat}>
      <div className={style.topbar}>{t("Choose friend to invite")}</div>
      <div className={style.contentContainer}>
        <div className={style.friendsContainer}>
          <div className={style.searchContainer}>
            <div
              className={style.searchIcon}
              style={{ backgroundImage: `url(${searchIcon})` }}
            />
            <input
              type="text"
              className={style.searchInput}
              placeholder={t("Search")}
              onChange={handleSearch}
              value={search}
            />
            {search && (
              <CloseCircleOutlined
                className={style.clearSearchBtn}
                onClick={handleClearSeaech}
              />
            )}
          </div>
          <div className={style.title}>{t("My Friends")}</div>
          <div className={style.FriendItemContainer}>
            {outsideGroup.loading && friendsInvite.loading &&
              [0, 0, 0].map(() => {
                return <FriendItemSkeleton />;
              })}

            {friendsOutside.length !== 0 ? friendsOutside?.map((item: any, idx: any) => {
              return (
                <FriendItem
                  key={idx}
                  id={item?.friend?.id}
                  name={getFullName(item?.friend)}
                  onClick={handleClickSelect}
                  checked={membersID.includes(item?.friend?.id)}
                  image={item?.friend?.imageProfileURL}
                />
              );
            }) : null}

            {friendsInvite.length !== 0
              ? friendsInvite.map((item: any, idx: any) => {
                return (
                  <FriendInvitItem
                    key={idx}
                    id={item?.user?.id}
                    name={getFullName(item?.user)}
                    image={item?.user?.imageProfileURL}
                  />
                );
              }) : null}

            {!outsideGroup.loading && !friendsInvite.loading &&
              (friendsOutside.length === 0 && friendsInvite.length === 0) ? (
              <div className={style.notFound}>{t("Not found user")}</div>
            ) : null}
          </div>
        </div>
        <div className={style.selectedContainer}>
          <div className={style.selectedGroup}>
            {membersName.length !== 0
              ? membersName.map((member: any, idx: number) => {
                return (
                  <FriendSelected
                    key={idx}
                    name={member.name}
                    onClose={handleClickSelect}
                    member={member}
                  />
                );
              })
              : null}
          </div>
          <div className={style.buttonContainer}>
            <CenterButton onClick={handleCancel}>
              {t("Cancel")}
            </CenterButton>
            {/* <button
              type="button"
              className={style.cancelBtn}
              onClick={handleCancel}
            >
              {t("Cancel")}
            </button> */}
            <div style={{ marginLeft: "30px" }}></div>
            {membersID.length === 0 ? (
              <div style={{ pointerEvents: "none", cursor: "default" }}>
                <CenterButton ghost disabled >{t("Add")}</CenterButton>
              </div>
            ) : (
              <CenterButton onClick={addMember}>
                {!invite.loading ? (
                  t("Add")
                ) : (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: "25px", color: "#FFFFFF" }}
                      />
                    }
                  />
                )}
              </CenterButton>
            )}
            {/* <button
              disabled={membersID.length === 0}
              type="button"
              className={
                membersID.length === 0 ? style.addDisableBtn : style.addBtn
              }
              onClick={addMember}
              style={{ marginLeft: "30px" }}
            >
              {!invite.loading ? (
                t("Add")
              ) : (
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: "25px", color: "#FFFFFF" }}
                    />
                  }
                />
              )}
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

const FriendItem = (props: any) => {
  const { name, onClick, checked, image, id } = props;

  return (
    <div
      className={style.friendItem}
      onClick={() => {
        onClick({ id: id, name: name });
      }}
    >
      <div style={{ width: "50px" }}>
        <div
          className={style.profileImage}
          style={{ backgroundImage: `url(${getUrlHttp(image)})` }}
        ></div>
      </div>

      <div style={{ width: "calc(100% - 50px - 40px - 20px)" }}>
        <label className={style.name} style={{ marginLeft: "40px" }}>
          {name}
        </label>
      </div>
      <div style={{ display: "flex", width: "20px" }}>
        <input
          checked={checked}
          onChange={() => { }}
          type="checkbox"
          id="friendCheckbox"
          className={style.friendCheckbox_input}
          style={{ visibility: "hidden" }}
        />
        {/* <div className={style.friendCheckbox} /> */}
        <div
          className={style.selected}
          style={{ backgroundImage: `url(${selectedItemShare})` }}
        />
      </div>
    </div>
  );
};

const FriendInvitItem = (props: any) => {
  const { t } = useTranslation();
  const { name, image } = props;

  return (
    <div className={style.friendInvitItem}>
      <div style={{ width: "50px" }}>
        <div
          className={style.profileImage}
          style={{ backgroundImage: `url(${getUrlHttp(image)})` }}
        ></div>
      </div>

      <div style={{ width: "calc(100% - 50px - 40px - 20px)" }}>
        <label className={style.nameInvite} style={{ marginLeft: "40px" }}>
          {name}
        </label>
      </div>
      <div style={{ display: "flex", width: "80px" }}>
        <label className={style.textrequested}>
          {t("Requested")}
        </label>
      </div>
    </div>
  );
};

const FriendItemSkeleton = (props: any) => {
  return (
    <SkeletonTheme color="#E3E3E3" highlightColor="#EEEEEE">
      <div className={style.friendItem}>
        <Skeleton
          count={1}
          style={{ width: "77px", height: "77px", borderRadius: "50%" }}
        />
        {/* <div className={style.profileImage}></div> */}
        {/* <label className={style.name} style={{ marginLeft: "40px" }}></label> */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Skeleton
            count={1}
            style={{ marginLeft: "40px", width: "200px", height: "20px" }}
          />
          <Skeleton
            count={1}
            style={{ marginLeft: "40px", width: "100px", height: "20px" }}
          />
        </div>
      </div>
    </SkeletonTheme>
  );
};

const FriendSelected = (props: any) => {
  const { name, onClose, member } = props;
  return (
    <Tooltip placement="bottom" title={member.name}>
      <div className={style.friendSelected}>
        <div className={style.nameContainer}>{name}</div>
        <div
          className={style.closeIcon}
          style={{ backgroundImage: `url(${close})` }}
          onClick={() => onClose(member)}
        />
      </div>
    </Tooltip>
  );
};

export default InviteChat;
